import { render } from "./SignInIcon.vue?vue&type=template&id=0120ef8d&scoped=true"
import script from "./SignInIcon.vue?vue&type=script&lang=js"
export * from "./SignInIcon.vue?vue&type=script&lang=js"

import "./SignInIcon.vue?vue&type=style&index=0&id=0120ef8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0120ef8d"]])

export default __exports__